import SFetch from '@app/utils/sfetch'

function moveExport(exportId) {
  const url = Silverfin.Routes.move_modal_permanent_entries_path({
    firm_id: Silverfin.currentFirmId,
    company_id: Silverfin.currentCompanyId,
    type: 'export',
    id: exportId,
    _options: true,
  })

  return SFetch.json(url, { method: 'GET' }).then((response) => {
    window.modalCitizen.openModal('move-document-modal', response)
  })
}

function moveExports(exportIds) {
  const url = Silverfin.Routes.batch_move_exports_modal_permanent_entries_path({
    firm_id: Silverfin.currentFirmId,
    company_id: Silverfin.currentCompanyId,
    export_ids: exportIds,
    _options: true,
  })

  return SFetch.json(url, { method: 'GET' }).then((response) => {
    window.modalCitizen.openModal('move-document-modal', response)
  })
}

function deleteExport(exportId) {
  const url = Silverfin.Routes.export_path({
    firm_id: Silverfin.currentFirmId,
    company_id: Silverfin.currentCompanyId,
    id: exportId,
    _options: true,
  })

  return SFetch.json(url, { method: 'DELETE' }).then((response) => {
    window.Turbolinks.visit(response.redirectTo)
  })
}

function deleteExports(exportIds) {
  const url = Silverfin.Routes.batch_destroy_exports_path({
    firm_id: Silverfin.currentFirmId,
    company_id: Silverfin.currentCompanyId,
    ids: exportIds,
    _options: true,
  })

  return SFetch.json(url, { method: 'DELETE' }).then((response) => {
    window.Turbolinks.visit(response.redirectTo)
  })
}

export default { moveExport, moveExports, deleteExport, deleteExports }
